import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'

const reasons = [
  'Categorises, filters, and prioritises all mail',
  'Blocks junk automatically',
  'Creates team-based delivery rules and notifications',
  'Forwards essential post automatically when needed',
]

const YourMailAssistant = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot holding phone as mail assistant',
        desktop: {
          dimensions: {
            height: 540,
            width: 634,
          },
          src: '/images/new/au/robot-holding-phone-crop.png',
        },
        mobile: {
          dimensions: {
            height: 830,
            width: 400,
          },
          src: '/images/new/au/robot-holding-phone-mobile.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '45%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
      reverseColumnOrder
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4  pe-lg-17 pt-5 py-lg-18 mb-lg-0 mb-n10'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105'>
          Your <span className='color-pink2'>AI-Powered</span> Mail Assistant
        </h3>
        <ul className='list-unstyled d-flex flex-column gap-4'>
          {reasons.map((reason, index) => (
            <li key={index} className='fs-fluid-20-26 fw-semibold lh-119 px-0'>
              {reason}
            </li>
          ))}
        </ul>
      </div>
    </LeftRobotCard>
  )
}

export default YourMailAssistant
